import React from 'react';

import { connect } from 'react-redux';
import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';

import { updateSurveyResponse } from '../actions/survey/update-survey-response';

import { UiDialog } from '../../ui/ui-dialog';

import { SingleLanguageMessageComposer } from '../../widgets/message-composer/wrappers/single-language-message-composer';

type InputProps = {
  editSurveyResponseId: number | null;
  onClose: () => void;
};
type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type Props = InputProps & DispatchProps;

const mapDispatchToProps = (dispatch: ThunkDispatch<any, any, AnyAction>) => ({
  actions: {
    updateSurveyResponse: (surveyResponseId: number, manualResponse: string) =>
      dispatch(updateSurveyResponse(surveyResponseId, { manualResponse })),
  },
});

export const AddResponseDialog = connect(
  null,
  mapDispatchToProps,
)(({ actions, editSurveyResponseId, onClose }: Props) => {
  const handleSaveMessageForEmployee = async (messageBody: string) => {
    if (!editSurveyResponseId) {
      return null;
    }
    return actions.updateSurveyResponse(editSurveyResponseId, messageBody).then((resp) => {
      onClose();
      return resp;
    });
  };

  return (
    <UiDialog size="xs" onClose={onClose} title="Add Response">
      <UiDialog.Content>
        <div>Please enter the response you&apos;d like for this employee</div>
        <SingleLanguageMessageComposer
          enableText
          enableEmail={false}
          onSendMessage={handleSaveMessageForEmployee}
          onMessageSent={onClose}
          buttonText="Save Response"
        />
      </UiDialog.Content>
    </UiDialog>
  );
});
